import { Pipe, PipeTransform } from '@angular/core';
import { LicenseType } from '@models/license';

@Pipe({
  name: 'ilLicenses'
})
export class ILLicensesPipe implements PipeTransform {
  transform(licenses: LicenseType[]): LicenseType[] {
    if (!licenses) {
      return licenses;
    }

    return licenses.filter((license) => {
      return license.course?.courseItems?.some((item) => item.ilCourse !== null);
    });
  }
}
